export default "/dist/files/programmees_vide.8327d2c4e142c1841b8b5b31579fd776.svg";